import React, { useState, useContext } from 'react';
import { Card, Form, Alert, Spinner, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useRequestPasswordReset } from '../hooks/useBackend';
import { AuthContext } from '../contexts/AuthContext';
import LoadingSpinner from '../components/shared/LoadingSpinner';
import LandingNav from '../components/shared/LandingNav';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const { data, error, loading, requestPasswordReset } = useRequestPasswordReset();
  const { isInitializing } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await requestPasswordReset(email);
    setSubmitted(true);
  };

  // Show loading spinner while fetching settings from cached token
  if (isInitializing) {
    return (
      <div style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg-primary, #0f172a)',
        zIndex: 2000
      }}>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <>
      <LandingNav />
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 80px)',
        padding: '20px'
      }}>
        <Container style={{ maxWidth: '520px', width: '100%' }}>
          <Card className="bg-dark text-light border-secondary" style={{ boxShadow: '0 12px 30px rgba(0,0,0,0.35)', borderRadius: 12 }}>
            <Card.Header as="h5" className="bg-dark text-light border-secondary">Forgot Password</Card.Header>
            <Card.Body className="bg-dark text-light" style={{ padding: '2.5rem' }}>
              {submitted ? (
                <Alert variant="info" className="bg-dark text-light border-info">
                  If an account exists for this email, you will receive a password reset link.
                </Alert>
              ) : (
                <Form onSubmit={handleSubmit} style={{ marginTop: '30px', paddingBottom: '1rem' }}>
                  <style>{`
                    #formEmail:focus {
                      outline: 2px solid var(--accent, #8B5CF6) !important;
                      outline-offset: 2px !important;
                      border-color: var(--accent, #8B5CF6) !important;
                      box-shadow: 0 0 0 0.2rem rgba(139, 92, 246, 0.25) !important;
                    }
                  `}</style>
                  <Form.Group controlId="formEmail" className="mb-4">
                    <Form.Label>Email</Form.Label>
                    <Form.Control 
                      type="email" 
                      value={email} 
                      onChange={e => setEmail(e.target.value)}
                      required
                      className="bg-dark text-light"
                      style={{ backgroundColor: 'var(--dark-bg-input)', borderColor: 'var(--accent)', outline: 'none', boxShadow: 'none' }}
                    />
                  </Form.Group>
                  
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }}>
                    <button 
                      type="submit" 
                      disabled={loading}
                      style={{
                        background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)',
                        color: '#fff',
                        border: 'none',
                        fontSize: '1.1em',
                        padding: '12px 28px',
                        borderRadius: '50px',
                        fontWeight: '600',
                        transition: 'transform 0.2s, box-shadow 0.2s',
                        boxShadow: '0 2px 8px rgba(139, 92, 246, 0.2)',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: loading ? 'not-allowed' : 'pointer',
                        opacity: loading ? 0.7 : 1,
                        minWidth: '180px'
                      }}
                      onMouseEnter={e => {
                        if (!loading) {
                          e.target.style.transform = 'translateY(-2px)';
                          e.target.style.boxShadow = '0 4px 12px rgba(139, 92, 246, 0.3)';
                        }
                      }}
                      onMouseLeave={e => {
                        if (!loading) {
                          e.target.style.transform = 'translateY(0)';
                          e.target.style.boxShadow = '0 2px 8px rgba(139, 92, 246, 0.2)';
                        }
                      }}
                    >
                      {loading ? <Spinner animation="border" size="sm" /> : 'Send Reset Link'}
                    </button>
                  </div>
                </Form>
              )}
              
              <div style={{ 
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '24px',
                paddingTop: '20px',
                borderTop: '1px solid rgba(255, 255, 255, 0.1)'
              }}>
                <small className="text-muted">
                  Remember your password?{' '}
                  <Link to="/login" className="text-decoration-none" style={{ color: 'var(--accent)' }}>
                    Back to Login
                  </Link>
                </small>
              </div>
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default ForgotPassword;


